<template>
    <div>
        <common-table :form-fields="formFields"
                      :table-columns="tableColumns"
                      :url="url"
                      :searchs="searchs"
                      :permission="permission"
                      :operate="operate"
                      ref="table"
        />

    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "QuantificationLimits",
        components: {CommonTable},
        data() {
            return {

                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }],
                permission:{
                    add: 'quantificationLimits:add',
                    update: 'quantificationLimits:update',
                    delete: 'quantificationLimits:delete',
                    deleteBatch: 'quantificationLimits:deleteBatch'
                },
                url: {
                    get: '/quantificationLimits/listByCondition',
                    add: '/quantificationLimits/add',
                    update: '/quantificationLimits/update',
                    delete: '/quantificationLimits/delete/',
                    delete_batch: '/quantificationLimits/deleteBatch',
                    status: '/quantificationLimits/update'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '100',
                }, {
                  field: 'agentId',
                  label: '代理',
                  selectUrl: '/agent/getAll',
                  selectData: [],
                  show: {
                    type: 'select',
                  },
                  detail: false,
                  width: '',
                }, {
                    field: 'ratio',
                    label: '提/充比',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    width: '',
                }/*,{
                    field: 'text',
                    label: '弹窗内容',
                    show: true,
                    width: '',
                }*/,{
                    field: 'status',
                    label: '状态',
                    show: true,
                    width: '90',
                    status: true,
                }],
                formFields: {
                    addTitle: '添加配置',
                    updateTitle: '修改配置',
                    labelWidth: '100px',
                    toTree: false,
                    model: [{
                      field: 'agentId',
                      label: '代理：',
                      type: 'select',
                      placeholder: '请选择代理',
                      rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
                      selectUrl: '/agent/getAll',
                      selectData: [],
                      add: true,
                      update: true,
                      filterable: true,
                    },  {
                        field: 'ratio',
                        label: '提/充比',
                        type: 'money',
                        placeholder: '提/充比(%)',
                        rules: [{
                            message: '请输入提/充比', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }/*, {
                        field: 'text',
                        label: '弹窗内容',
                        type: 'editor',
                        placeholder: '弹窗内容',
                        rules:[{
                            message: '请输入弹窗内容', trigger: 'blur', required: false
                        }],
                        add: true,
                        update: true,
                        default: 0
                    }*/]
                },
                operate: []
            }
        },
        methods: { },
    }
</script>

<style scoped>
    .domain {
        max-width: 350px;
    }
</style>
